module.exports = __webpack_public_path__ + "img/vecernji.c58200c8.png";